import styled from 'styled-components';
import colors from '@designSystem/colors';

type StyledSearchInputI = {
  newDesign?: boolean;
};

export const StyledSearchInput = styled.input<StyledSearchInputI>`
  width: 100%;
  height: 40px;
  background: ${colors.lightGrey};
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  padding-left: 16px;
  border: 1.5px solid ${colors.grey};
`;

type SearchInputContainerI = {
  fixedWidth?: number;
};

export const SearchInputContainer = styled.div<SearchInputContainerI>`
  display: flex;
  align-items: center;
  position: relative;
  width: ${({ fixedWidth }) => (fixedWidth ? `${fixedWidth}px` : '100%')};
`;

export const SearchIconContainer = styled.div`
  display: flex;
  position: absolute;
  right: 24px;

  & svg {
    & path {
      fill: ${colors.darkGrey};
    }
  }
`;
